export default {"src":"/_next/static/media/icon.adb94e0a.svg","height":515,"width":514,"blurWidth":0,"blurHeight":0};